import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, Checkboxes,  RequiredValidator, Services, TextField } from '../../Components/Form';
import { usePricingCategories } from '../../Data/PricingCategories';
import Loading from '../../Components/Loading';
import { ulid } from 'ulid';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';

const AddCategory = ({isOpen, onSave, existing, onClose}) => {
    const {categories, addCategory} = usePricingCategories(true);

    const saveCategories = async (data) => {
        if (data.categories) {
            data.categories.forEach(categoryId => {
                const cat = categories.find(c => c.id === categoryId);
                onSave({
                    ...cat,
                    items: [], // Make sure we don't add in every item
                });
            });
        }

        if (data.name) {
            const newCat = {
                pricingCategoryId: ulid(),
                name: data.name,
                description: data.description,
                services: data.services,
                items: [],
            };
            await addCategory(newCat);
            onSave(newCat);
        }
    }
    
    return <Modal title="Add Categories" isOpen={isOpen} setIsOpen={onClose} dismissible>
        <Tabs selected={(categories && categories.length === 0) ? 'New' : 'Existing'}>
            <Tab icon="ListCheck" title="Existing">
                <Form onSubmit={saveCategories} closeModalOnSubmit>
                    <ExistingCategories categories={categories} existing={existing} />
                    <Actions submit cancel />
                </Form>
            </Tab>
            <Tab icon="Plus" title="New">
                <Form onSubmit={saveCategories} closeModalOnSubmit>
                    <TextField name="name" label="Name" validators={[RequiredValidator]} />
                    <TextField name="description" label="Description" validators={[]} />
                    <Services name="services"
                        label="Services"
                        validators={[RequiredValidator]}
                        help="Associate the category with services it's relevant to."
                    />
                    <Actions submit cancel />
                </Form>
            </Tab>
        </Tabs>
    </Modal>
}

const ExistingCategories = ({categories, existing}) => {
    if (categories === null) {
        return <Loading size="2x" center />;
    }

    if (categories.length === 0) {
        return <p className="text-center text-muted">
            No existing categories to add.<br />
            Use the 'New' tab to add a new category, which will be available here next time.
        </p>
    }

    return <>
        <Checkboxes label="Categories"
            name="categories"
            options={categories.filter(c => !existing.find(e => e.id === c.id)).map(c => ({value: c.id, label: c.name}))}
            validators={[RequiredValidator]}
        />
    </>
}

export default AddCategory;